import {
  type ApplicationDataType,
  ApplicationListItem,
} from '@/components/contacts/application-list/application-list-item';
import { useRespondFriendApplication } from '@/hooks/users/use-friend-applications';

interface Props {
  application: ApplicationDataType;
}

export default function FriendApplicationListItem({ application }: Props) {
  const { isPending, mutateAsync } = useRespondFriendApplication(application);

  return (
    <ApplicationListItem
      application={application}
      isLoading={isPending}
      onRespond={mutateAsync}
    />
  );
}
